import { usePermissions } from "./usePermissions";

/**
 * Checks whether the currently signed in user has any the specified permissions.
 * @param permissions The set of permissions to check for.
 * @returns `true` if the user has any of the permissions, otherwise `false`.
 */
export function useLoosePermissionCheck(permissions: ReadonlyArray<string>): boolean {
  const [shellPermissions] = usePermissions();
  const shellPermissionsSet = new Set(shellPermissions);

  for (const permission of permissions) {
    if (shellPermissionsSet.has(permission)) return true;
  }

  return false;
}
